export enum TipoFatoGeradorEnum {

  NFE = "Nota fiscal eletrônica",
  ESCRIT_PAPEL = "Notas de papel",
  ESCRIT_BANCO = "Bancos",
  ESCRIT_ESPECIAL = "Escrituração especial"
}
